<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <web-components-user-notes target="posteingang" [dismissibleNotes]="true" />
      </div>
    </div>

    <div class="tile">
      <div class="row mb-4">
        <div class="col-12">
          <h1 class="zero-text p-huge-med">
            {{ 'post-box.headline' | transloco }}
          </h1>
        </div>
      </div>

      @if (showPost) {
        <div class="row">
          <div class="col-12">
            <div class="nav nav-tabs cursor-pointer margin-bottom-30">
              <div class="nav-item">
                <a class="nav-link" [class.active]="category === 'P'" (click)="changeCategory('P')">
                  <div class="text-center text-nowrap">
                    {{ 'post-box.tabs.inbox' | transloco }}
                    @if (dataService.unreadDocuments.eingang > 0) {
                      <span class="badge badge-pill badge-alert ml-1">{{ dataService.unreadDocuments.eingang }}</span>
                    }
                  </div>
                </a>
              </div>
              <div class="nav-item">
                <a class="nav-link text-center text-nowrap" [class.active]="category === 'A'" (click)="changeCategory('A')">
                  {{ 'post-box.tabs.archive' | transloco }}
                </a>
              </div>
              <div class="nav-item">
                <a class="nav-link" [class.active]="category === 'M'" (click)="changeCategory('M')">
                  <div class="text-center text-nowrap">
                    {{ 'post-box.tabs.mifid' | transloco }}
                    @if (dataService.unreadDocuments.mifid > 0) {
                      <span class="badge badge-pill badge-alert ml-1">{{ dataService.unreadDocuments.mifid }}</span>
                    }
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-20" [zeroLoadingIndicator]="updating">
          <div class="col-12 col-lg-8">
            <div class="inbox d-flex flex-wrap flex-grow mb-4 asset-search">
              <div class="flex-grow-1 input-group-material input-group-right keepcolor">
                <div class="input-group-material-icon text-color-basic">
                  <svg class="icon mirror">
                    <use xlink:href="/assets/img/svgs/svgset.svg#search" />
                  </svg>
                </div>
                <input
                  id="docsearch"
                  type="text"
                  spellcheck="false"
                  [(ngModel)]="searchTerm"
                  #searchInput
                  [class.empty]="!searchInput.value"
                  (ngModelChange)="searchChanged()"
                  [placeholder]="'post-box.search' | transloco"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 d-flex">
            <div class="flex-grow input-group-material padding-bottom-15 keepcolor padding-right-10 w-25">
              <input
                type="text"
                class="date"
                [(ngModel)]="vonDatum"
                name="vonDatumInput"
                id="vonDatumInput"
                (ngModelChange)="filter()"
                #vonDatumInputVar="ngModel"
                [class.empty]="!vonDatumInputVar.value"
                ngbDatepicker
                #d1="ngbDatepicker"
                [minDate]="{ year: 2019, month: 1, day: 1 }"
                #vonDatumInputRef
                (focus)="openDatenpicker($event, d1, vonDatumInputRef, 'vonDatum')"
                [maxDate]="{ year: currentYear, month: 12, day: 31 }"
                [placeholder]="'post-box.date-picker.from' | transloco"
              />
              @if (vonDatum) {
                <span class="input-group-material-icon-state"></span>
              }
            </div>
            <div class="flex-grow input-group-material padding-bottom-15 keepcolor w-25">
              <input
                type="text"
                class="date"
                [(ngModel)]="bisDatum"
                name="bisDatumInput"
                id="bisDatumInput"
                (ngModelChange)="filter()"
                #bisDatumInputVar="ngModel"
                [class.empty]="!bisDatumInputVar.value"
                ngbDatepicker
                #d2="ngbDatepicker"
                [minDate]="{ year: 2019, month: 1, day: 1 }"
                #bisDatumInputRef
                (focus)="openDatenpicker($event, d2, bisDatumInputRef, 'bisDatum')"
                [maxDate]="{ year: currentYear, month: 12, day: 31 }"
                [placeholder]="'post-box.date-picker.to' | transloco"
              />
              @if (bisDatum) {
                <span class="input-group-material-icon-state"></span>
              }
            </div>
          </div>
          <div class="col-12">
            <div class="inbox pt-2">
              <table class="table-post" @onlyEnter aria-describedby="table-posts">
                <tbody>
                  <tr>
                    <th class="cursor-pointer no-select">
                      <span [ngClass]="sorter.getSorterClasses('after', 'title')" (click)="sortBy('title')">
                        {{ 'post-box.table.header.title' | transloco }}
                      </span>
                    </th>
                    <th class="cursor-pointer no-select" [ngStyle]="{ minWidth: '7rem' }">
                      <span [ngClass]="sorter.getSorterClasses('before', 'date')" (click)="sortBy('date')">
                        {{ 'post-box.table.header.date' | transloco }}
                      </span>
                    </th>
                    <th class="cursor-pointer no-select">
                      <div class="d-flex">
                        @if (category !== 'A') {
                          <span
                            [ngStyle]="{ minWidth: '7rem' }"
                            class="pr-3"
                            [ngClass]="sorter.getSorterClasses('before', 'read')"
                            (click)="sortBy('read')"
                          >
                            {{ 'post-box.table.header.read' | transloco }}
                          </span>
                          @if (category !== 'A') {
                            {{ 'post-box.table.header.archive' | transloco }}
                          }
                        } @else {
                          <span
                            [ngStyle]="{ minWidth: '7rem' }"
                            [ngClass]="sorter.getSorterClasses('before', 'readAt')"
                            (click)="sortBy('readAt')"
                          >
                            {{ 'post-box.table.header.archived' | transloco }}
                          </span>
                        }
                      </div>
                    </th>
                  </tr>
                  @for (p of filteredDocuments | slice: 0 : max; track $index) {
                    <tr>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="hidden-md hidden-lg hidden-xl mr-5">Titel</div>
                          <div>
                            <a
                              class="zero-text default"
                              [ngClass]="p.read ? 'p-base-reg' : 'p-base-bold'"
                              [href]="p | pdfUri"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="setGelesen(p)"
                            >
                              {{ p | postTitle }}
                            </a>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center justify-content-end">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">Datum</div>
                          {{ p.date | date }}
                        </div>
                      </td>
                      <td>
                        <div class="align-items-center d-flex flex-grow justify-content-end justify-content-md-center">
                          <div class="d-flex flex-grow justify-content-end">
                            <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">Gelesen</div>
                            <div class="flex-grow d-flex justify-content-end justify-content-md-center mt-2">
                              @if (!p.archived) {
                                <label [for]="p.id + '-archived'" class="checkbox">
                                  <input [id]="p.id + '-archived'" type="checkbox" (change)="toggleGelesen(p)" [checked]="p.read" />
                                  <span class="checkmark"> &nbsp; </span>
                                </label>
                              }
                            </div>
                            @if (p.archived) {
                              <div class="text-align-center">
                                {{ p.readAt | date }}
                              </div>
                            }
                            @if (category !== 'A') {
                              @if (!p.archived) {
                                <div class="btn-icon ml-2 cursor-pointer" (click)="archive(p)">
                                  <svg class="icon icon-24 icon-active">
                                    <use xlink:href="/assets/img/svgs/svgset.svg#archive-redesign" />
                                  </svg>
                                </div>
                              }
                              @if (p.archived) {
                                <div class="btn-icon ml-2">
                                  <svg class="icon icon-24 icon-inactive">
                                    <use xlink:href="/assets/img/svgs/svgset.svg#archive-redesign" />
                                  </svg>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-start pl-2">
              <a [class.hidden]="max >= filteredDocuments.length" (click)="mehr()" class="no-select link-secondary cursor-pointer">
                {{ 'post-box.links.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
              </a>
            </div>
            <div class="d-flex justify-content-end">
              @if (category !== 'A') {
                <a class="link-secondary mr-4 cursor-pointer" (click)="setAllRead(category)">{{
                  'post-box.links.mark-as-read' | transloco
                }}</a>
                <a class="link-secondary cursor-pointer" (click)="setAllArchived(category)">{{ 'post-box.links.archive' | transloco }}</a>
              }
            </div>
          </div>
        </div>
      }
      <div class="row text-color-error text-size-medium margin-bottom-20">
        <div class="col-12">
          <web-components-user-messages />
        </div>
      </div>
    </div>
  </div>
</div>
